// @flow

import type { LinksItemType } from '../../../../common/types/links/linksItem';
import type { LinksType } from '../../../../common/types/links/links';

export type KeysToMap = Array<{
  from: string,
  to: string,
}>;

export default function map(
  responseApiSearchAdsLinks: ?Array<Object>,
  keysToMap: KeysToMap
): LinksType {
  if (!responseApiSearchAdsLinks) {
    return [];
  }

  return responseApiSearchAdsLinks.map(searchAdsLinksItem => {
    const linkMapped: LinksItemType = { text: '', path: '' };
    keysToMap.forEach(keyToMap => {
      linkMapped[keyToMap.to] = searchAdsLinksItem[keyToMap.from];
    });

    return linkMapped;
  });
}



// WEBPACK FOOTER //
// ./app/Serp/mappers/apiSearchResponse/common/linksMapper.js